<template lang='html'>
  <app-layout swipe @swipeRight="swipeRight" @swipeLeft="swipeLeft">

    <template slot="top">
      <div class="brow align-items-center grey lighten-2 brown--text text--darken-2">
        <div class="col-3 lft">
          <v-btn color="brown darken-3" @click="$refs.calendar.prev()" class="tight amber--text">
            <i class="icon-arrow-left2"/>
          </v-btn>
        </div>
        <div class="col-6 noWrap">
          {{ title }}
        </div>
        <div class="col-3 rgt">
          <v-btn color="brown darken-3" @click="$refs.calendar.next()" class="tight amber--text" v-if="next">
            <i class="icon-arrow-right2"/>
          </v-btn>
        </div>
      </div>
    </template>

    <v-calendar
          ref="calendar"
          v-model="date"
          type="month"
          color="primary"
          :weekdays="[1, 2, 3, 4, 5, 6, 0]"
          locale="de-de"
          @change="calendarChanged"
        >
      <template v-slot:day="{ date }">
            <template v-for="event in eventsMap[date]">
              <v-menu
                :key="event.title"
                v-model="event.open"
                full-width
                offset-x
              >
                <template v-slot:activator="{ on }">
                  <div
                    v-if="!event.time"
                    v-ripple
                    class="my-event"
                    v-on="on"
                  >
                    <img :src="event.imageUrl" class="responsive" />
                  </div>
                </template>
                <v-card
                  color="grey lighten-4"
                  min-width="350px"
                  flat
                >
                  <v-toolbar
                    color="primary"
                    dark
                  >
                    <v-toolbar-title v-html="event.title"></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-title primary-title>
                    <span v-html="event.details"></span>
                    <img :src="event.imageUrl" class="responsive" />
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      flat
                      color="secondary"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>
          </template>

    </v-calendar>

    <bottom-nav />

  </app-layout>
</template>

<script>
// import { mapGetters } from 'vuex';
import axios    from '@/services/axios';
import BottomNav from '@/components/layout/BottomNav'
import { assignResponse } from '@/utils/decoder'

export default {
  name: 'Calendar',
  components: {
    BottomNav
  },
  data() {
    return {
      today:  ( new Date() ).toISOString().split("T")[0],
      date:   ( new Date() ).toISOString().split("T")[0],
      months: ['', 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      events: []
    }
  },
  methods: {
    swipeRight() {
      this.$refs.calendar.prev()
    },
    swipeLeft() {
      if (this.next) {
        this.$refs.calendar.next()
      }
    },
    calendarChanged( obj ) {
      console.log("calendarChanged", obj)
      this.getWorkouts(obj.start.date)
    },
    getWorkouts(datum) {
      axios.get( '/workouts/by_month/' + datum).then((resp) => {
        let collection = assignResponse(resp)
        console.log('getWorkouts  | ', collection )
        this.events = collection
      })
    }
  },
  computed: {
    title() {
      return `${ this.months[parseInt(this.date.split('-')[1])] }. ${this.date.split('-')[0]}`
    },
    eventsMap () {
      const map = {}
      this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
      return map
    },
    next() {
      return this.date.split('-').splice(0,2).join('-') !== this.today.split('-').splice(0,2).join('-')
    }
  },
  mounted() {
    this.getWorkouts( this.date )
  }
}
</script>

<style lang='scss' scoped>

</style>